import { RadioSchedule } from '@/models/RadioTypes';

export const PAKKAFORM_ID = 'pakkaform';

export const BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1224,
  xxl: 1536,
};
export const FAQFORM_ID = 'spurningar';

export const ALLOWED_CHANNELS = [
  'stod2',
  'sport',
  'sport2',
  'sport4',
  'golfstodin',
  'vodasport',
  'besta01',
  'besta02',
  'besta03',
  'syn',
  'synplus',
  'synsport',
  'synsport2',
  'synsport3',
  'synsport4',
  'synsportviaplay',
  'synsportisland',
  'synsportisland2',
  'synsportisland3',
  'synsportisland4',
  'synsportisland5',
];

export const ALLOWED_LIVE_CHANNELS = [
  'sport',
  'sport2',
  'sport4',
  'golfstodin',
  'vodasport',
  'synsport',
  'synsport2',
  'synsport3',
  'synsport4',
  'synsport5',
  'synsport6',
  'synsportviaplay',
  'synsportisland',
  'synsportisland2',
  'synsportisland3',
  'synsportisland4',
  'synsportisland5',
  'ap_kkitv_001_prod',
  'ap_kkitv_002_prod',
  'ap_kkitv_003_prod',
  'ap_kkitv_004_prod',
  'ap_kkitv_005_prod',
  'ap_kkitv_006_prod',
  'ap_kkitv_007_prod',
  'ap_kkitv_008_prod',
  'ap_kkitv_009_prod',
  'ap_kkitv_010_prod',
  'ap_kkitv_011_prod',
  'ap_kkitv_012_prod',
  'ap_kkitv_013_prod',
  'ap_kkitv_014_prod',
  'ap_kkitv_015_prod',
];

export enum CHANNEL_NAMES {
  'beint' = 'Í beinni',
  'syn' = 'SÝN',
  'synplus' = 'SÝN+',
  'synsport' = 'SÝN Sport',
  'synsport2' = 'SÝN Sport 2',
  'synsport3' = 'SÝN Sport 3',
  'synsport4' = 'SÝN Sport 4',
  'synsport5' = 'SÝN Sport 5',
  'synsport6' = 'SÝN Sport 6',
  'synsportviaplay' = 'SÝN Sport Viaplay',
  'synsportisland' = 'SÝN Sport Ísland',
  'synsportisland2' = 'SÝN Sport Ísland 2',
  'synsportisland3' = 'SÝN Sport Ísland 3',
  'synsportisland4' = 'SÝN Sport Ísland 4',
  'synsportisland5' = 'SÝN Sport Ísland 5',
  'bio' = 'Bíó',
  'esport' = 'Esport',
  'golfstodin' = 'Sýn Sport 5',
  'stod3' = 'Sýn Fjölskylda',
  'pepsimax' = 'Sýn.is',
  'ap_kkitv_001_prod' = 'KKÍ TV 1',
  'ap_kkitv_002_prod' = 'KKÍ TV 2',
  'ap_kkitv_003_prod' = 'KKÍ TV 3',
  'ap_kkitv_004_prod' = 'KKÍ TV 4',
  'ap_kkitv_005_prod' = 'KKÍ TV 5',
  'ap_kkitv_006_prod' = 'KKÍ TV 6',
  'ap_kkitv_007_prod' = 'KKÍ TV 7',
  'ap_kkitv_008_prod' = 'KKÍ TV 8',
  'ap_kkitv_009_prod' = 'KKÍ TV 9',
  'ap_kkitv_010_prod' = 'KKÍ TV 10',
  'ap_kkitv_011_prod' = 'KKÍ TV 11',
  'ap_kkitv_012_prod' = 'KKÍ TV 12',
  'ap_kkitv_013_prod' = 'KKÍ TV 13',
  'ap_kkitv_014_prod' = 'KKÍ TV 14',
  'ap_kkitv_015_prod' = 'KKÍ TV 15',
  'default' = 'Beint sjónvarp',
}

export const LANGUAGES = [
  {
    value: 'IS',
    label: 'Íslenska',
  },
  {
    value: 'EN',
    label: 'Enska',
  },
];

export const DEFAULT_LANGUAGE = 'is';

export const RADIO_ALT_LOGOS: { [key: string]: string } = {
  APPARATID: '/images/apparatid_alt_logo.jpg',
  BYLGJAN: '/images/bylgjan_alt_logo.jpg',
  COUNTRY: '/images/country_bylgjan_alt_logo.jpg',
  FM957: '/images/fm957_alt_logo.jpg',
  GULLBYLGJAN: '/images/gullbylgjan_alt_logo.jpg',
  ISLENSKA: '/images/islenska_bylgjan_alt_logo.jpg',
  LETTBYLGJAN: '/images/lett_bylgjan_alt_logo.jpg',
  X977: '/images/x977_alt_logo.jpg',
  '80S': '/images/80s_bylgjan_alt_logo.jpg',
};

export const DEFAULT_SCHEDULE = {
  weekday: '',
  title: 'Tónlist',
  description: '',
  photo: '',
  timeFrom: '',
  timeTo: '',
  showId: '',
  host: '',
} as RadioSchedule;

export const RADIO_COLORS: { [key: string]: { primary: string; secondary: string } } = {
  APPARATID: {
    primary: '#FBAD29',
    secondary: '#FFFFFF',
  },
  BYLGJAN: {
    primary: '#1B1B56',
    secondary: '#FFFFFF',
  },
  COUNTRY: {
    primary: '#1B1B56',
    secondary: '#E75E19',
  },
  FM957: {
    primary: '#3DA82E',
    secondary: '#FFFFFF',
  },
  GULLBYLGJAN: {
    primary: '#1B1B56',
    secondary: '#FDB813',
  },
  ISLENSKA: {
    primary: '#1B1B56',
    secondary: '#CD1A2E',
  },
  LETTBYLGJAN: {
    primary: '#1B1B56',
    secondary: '#00A7D4',
  },
  X977: {
    primary: '#000000',
    secondary: '#FFFFFF',
  },
  '80S': {
    primary: '#1F1A6B',
    secondary: '#8D3594',
  },
  '': {
    primary: '#1B1B56',
    secondary: '#FFFFFF',
  },
};

export const RADIO_1X1_LOGOS: { [key: string]: string } = {
  APPARATID: '/images/apparatid_1x1_logo.jpg',
  BYLGJAN: '/images/bylgjan_1x1_logo.jpg',
  COUNTRY: '/images/country_bylgjan_1x1_logo.jpg',
  FM957: '/images/fm957_1x1_logo.jpg',
  GULLBYLGJAN: '/images/gullbylgjan_1x1_logo.jpg',
  ISLENSKA: '/images/islenska_bylgjan_1x1_logo.jpg',
  LETTBYLGJAN: '/images/lett_bylgjan_1x1_logo.jpg',
  X977: '/images/x977_1x1_logo.jpg',
  '80S': '/images/80s_bylgjan_1x1_logo.jpg',
};

export enum RADIO_STATIONS {
  BYLGJAN = 'BYLGJAN',
  X977 = 'X977',
  FM957 = 'FM957',
  GULLBYLGJAN = 'GULLBYLGJAN',
  LETTBYLGJAN = 'LETTBYLGJAN',
  COUNTRY = 'COUNTRY',
  ISLENSKA = 'ISLENSKA',
  '80S' = '80S',
  UTVARP_101 = '101',
  FMEXTRA = 'FMEXTRA',
  APPARATID = 'APPARATID',
  RAS1 = 'RAS1',
  RAS2 = 'RAS2',
  RETRO = 'RETRO',
  K100 = 'K100',
  RONDO = 'RONDO',
  BBCWS = 'BBCWS',
  TROLLI = 'trolli',
}

export const TV_SCHEDULE_ROOT = 'https://tv-schedule-data.s3.eu-west-1.amazonaws.com/';

export const NETS_CONTRACTS = {
  WEBSTORE: 'WEB-STORE',
  MAIN: 'MAIN',
} as const;

export const CATEGORY_NAME_MAP = {
  farsimar: 'Farsímar',
  snjallur: 'Snjallúr',
  spjaldtolvur: 'Spjaldtölvur',
  aukahlutir: 'Aukahlutir',
  endabunadur: 'Endabúnaður',
  heyrnatol: 'Heyrnartól',
  heyrnartol: 'Heyrnartól',
  bord: 'Borð',
  eign: 'Eign',
  fordi: 'Forði',
  frelsi: 'Frelsi',
  'gsm-tilbod': 'Farsíma tilboð',
  heimasimar: 'Heimasímar',
  'hugb-leyfi': 'Hubúnaðarleyfi',
  hysing: 'Hýsing',
  kaffihus: 'Kaffihús',
  mark: 'Mark',
  rekstarthjonusta: 'Rekstrarþjónusta',
  sim: 'SIM',
  skyjathjonusta: 'Skýjaþjónusta',
  snjallheimili: 'Snjallvörur',
  ymislegt: 'Ýmislegt',
  '': '',
} as const;

// Build was complaining about this not being initialized in the getServerSideProps
// when this was defined in @/config/constants - fb
export const CATEGORY_ID_MAP = {
  farsimar: 'GSM',
  snjallur: 'SNJALLÚR',
  spjaldtolvur: 'SPJALDTÖLV',
  aukahlutir: 'AUKAHLUTIR',
  endabunadur: 'ENDABÚNAÐ',
  heyrnatol: 'HEYRNARTÓL',
  heyrnartol: 'HEYRNARTÓL',
  bord: 'BORD',
  eign: 'EIGN',
  fordi: 'FORÐI',
  frelsi: 'FRELSI',
  'gsm-tilbod': 'GSM TILBOÐ',
  heimasimar: 'HEIMASÍMAR',
  'hugb-leyfi': 'HUGB_LEYFI',
  hysing: 'HÝSING',
  kaffihus: 'KAFFIHÚS',
  mark: 'MARK',
  rekstarthjonusta: 'REKSTR_THJ',
  sim: 'SIM',
  skyjathjonusta: 'SKYJATHJON',
  snjallheimili: 'SMARTHOME',
  ymislegt: 'ÝMISLEGT',
  '': '',
} as Record<string, string>;

export const PAYMENT_TYPES = {
  ELECTRONIC: 'ELECTRONIC',
  CREDITCARD: 'CREDITCARD',
  NEW_CARD: 'NEW_CARD',
} as const;

export const CONTENT_PROCESS_STATUSES = {
  DONE: 'DONE',
  INPROCESS: 'INPROCESS',
  PUBLISHED: 'PUBLISHED',
} as const;

export type PaymentTypes = 'ELECTRONIC' | 'CREDITCARD' | 'NEW_CARD';

// Translation map for Foxway InfoCard criteria (English -> Icelandic)
export const FOXWAY_CRITERIA_TRANSLATIONS: Record<string, string> = {
  'All criteria must be met before selecting "YES"!': 'Uppfylla þarf öll skilyrði til að geta valið "Já"!',
  'All criteria must be met before selecting "YES"': 'Uppfylla þarf öll skilyrði til að geta valið "Já"!',
  'Device can be turned on and off': 'Hægt er að kveikja og slökkva á tækinu',
  'Charging port is without visual damage': 'Hleðslutengi er án sýnilegra skemmda',
  'Device starts charging with charger connected': 'Tækið hleðst þegar tengt í hleðslu',
  'Device can be used without charger connected': 'Tækið er nothæft án þess að vera í hleðslu',
  'Device is not heavily deformed': 'Tækið er ekki áberandi bogið eða snúið',
  'Device is intact': 'Tækið er í heilu lagi',
  'Devices with visually swollen or damaged batteries pose safety risks, including overheating or fire hazards, and are therefore strictly prohibited from trade-in.':
    'Tæki með sýnilega bólgin eða skemmdar rafhlöður eru öryggishætta og geta því ofhitnað eða eru eldhætta og eru því stranglega bönnuð í skiptum.',
  'LCD is without any clear signs of discoloration (screenburn, dead pixels, spots)':
    'Skjárinn er án augljósra merkja um mislitun (skjábruna, dauðra pixla, bletta)',
  'Touchscreen is fully working (check edges of the screen)':
    'Snertiskjárinn virkar að fullu (athugaðu jaðra skjásins)',
  'Glass covering the LCD is without any missing pieces (it can be cracked)':
    'Glerið yfir skjánum er án þess að vanti í (það má vera með sprungur)',
  'If device has more than one screen, all screens are without LCD defects':
    'Ef tækið er með fleiri en einn skjá eru allir skjáir án LCD galla',
  'No light cutting lines on the folding area': 'Engar ljósar línur á brotsvæðinu',
  'Please do not remove factory installed screen protection film from Samsung Flip/Fold devices':
    'Vinsamlegast ekki fjarlægja verksmiðjuhlíf af Samsung Flip/Fold tækjum',
  'Display glass is without cracks or chips (check also on edges)':
    'Skjáglerið er án sprungna eða flísa (athugaðu einnig á jöðrum)',
  'There are no cracks, splits or fractures on the frame or back cover':
    'Engar sprungur, rifur eða brot á ramma eða bakhlíf',
  'There is no gap between backcover / screen and frame': 'Ekkert bil er milli bakhlífar/skjás og ramma',
  'The frame of the device is not bent': 'Rammi tækisins er ekki beygður',
  'Camera glass is not cracked': 'Myndavélaglerið er ekki sprungnað',
  'No parts are missing (battery, backcover, port cover, screws, sim tray)':
    'Engir hlutar vantar (rafhlaða, bakhlíf, tengjahlíf, skrúfur, SIM-bakki)',
  'Screen is not visibly loose (can see under the screen)': 'Skjárinn er ekki sjáanlega laus (sést undir skjáinn)',
  'No apparent modifications have been used': 'Engar augljósar breytingar hafa verið gerðar',
  'Foldable devices goes fully flat when opened': 'Fellanlegt tæki fer alveg flatt þegar það er opnað',
  'All buttons work easily (Home, Power, Volume and Mute), no excessive force is needed':
    'Allir takkar virka auðveldlega (Heim, Kveikja, Hljóðstyrkur og Þagga), ekki þarf of mikinn kraft',
  'No unoriginal parts or modifications have been used for buttons':
    'Engir óupprunalegir hlutar eða breytingar hafa verið gerðar á tökkum',
  'Additional criteria for foldable device:': 'Viðbótarskilyrði fyrir fellanlegt tæki:',
  'Additional criteria for foldable devices:': 'Viðbótarskilyrði fyrir fellanlegt tæki:',

  // Laptop Power criteria
  'Unit powers on when power button is pressed': 'Tölvan kveikir þegar ýtt er á aflrofann',
  'Unit powers on when': 'Tölvan kveikir þegar',
  'power button is pressed': 'ýtt er á aflrofann',
  'Unit stays on for atleast 7 seconds (power adapter may be connected)':
    'Tölvan helst kveikt í að minnsta kosti 7 sekúndur (aflstraumsbreytir má vera tengdur)',
  'Units battery is not visibly swollen': 'Rafhlaða tölvunnar er ekki sjáanlega bólgin',

  // Laptop LCD/Screen criteria
  'Screen & screen backlight turn on': 'Skjár og bakljós skjás kveikja',
  'Screen shows good picture (no vertical/horizontal lines, no light spots, no discoloration, no graphic anomalies (flickering etc.))':
    'Skjárinn sýnir góða mynd (engar lóðréttar/láréttar línur, engir ljósir blettir, engin mislitun, engar grafískar truflanir (blikkun o.s.frv.))',
  'Screen shows good picture': 'Skjárinn sýnir góða mynd',
  '(no vertical/horizontal lines, no light spots, no discoloration, no graphic anomalies (flickering etc.))':
    '(engar lóðréttar/láréttar línur, engir ljósir blettir, engin mislitun, engar grafískar truflanir (blikkun o.s.frv.))',
  'LCD area is not damaged (damage includes cracks, coating peeling issue, deep scratches, etc.)':
    'LCD svæðið er ekki skemmt (skemmdir innihalda sprungur, húðun að flagnast, djúpar rispur o.s.frv.)',
  'Glass covering the LCD is not damaged': 'Glerið sem hylja LCD er ekki skemmt',
  'NB keyboard marks are qualified under physical condition of the laptop and therefore affect "Is computer physically ok?" question':
    'ATH lyklaborðsmerki teljast undir líkamlegu ástandi tölvunnar og hafa því áhrif á spurninguna "Er útlitið í lagi?"',

  // Boot criteria
  'Unit turns on and boots up to Operating system or to BIOS menu (from internal disk drive)':
    'Tölvan kveikir og ræsir upp í stýrikerfi eða í BIOS valmynd (frá innbyggðum diskdrifi)',

  // Physical condition criteria for laptops
  'Unit does not have missing external parts (external battery, bottom case etc.)':
    'Tölvan vantar ekki ytri hluta (ytri rafhlaða, botnhlíf o.s.frv.)',
  'Unit does not have missing keycaps': 'Tölvan vantar ekki lyklahettur',
  'Unit enclosure is not cracked at any place (check near the ports, lid and bezel)':
    'Umgjörð tölvunnar er ekki sprungin neins staðar (athugaðu við tengi, lok og ramma)',
  'Units enclosure is not bent at a any place (check near the ports)':
    'Umgjörð tölvunnar er ekki beygð neins staðar (athugaðu við tengin)',
  'Unit does not have any dented or cracked corners': 'Tölvan er ekki með buldar eða sprungnar hornir',
  'Units enclosure is not deformed (i.e. caused by swollen battery)':
    'Umgjörð tölvunnar er ekki afmynduð (t.d. af völdum bólginnar rafhlöðu)',
  'Unit does not have keyboard wear marks (on display)': 'Tölvan er ekki með slitamerki frá lyklaborði (á skjá)',
};
